import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './pages/shared/shared.module';
import { AppComponent } from './app.component';
import { appComponents, appRoutes } from './app.routes';
import { RouteService } from './services/route.service';
import { RouteGuardsService } from './services/route-guards.service';
import { BootService } from './services/boot.service';
import { TranslateService } from './pages/shared/services/translate.service';
import { DropdownService } from './services/dropdown.service';
import { MatListModule } from '@angular/material/list';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthService } from './services/auth.service';
import 'hammerjs';
import { ItemService } from './services/item.service';
import { InterceptorService } from './services/interceptor.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterUtilityService } from './services/router.utility.service';
import { HttpService } from './services/http.service';
import { TimeService } from './pages/shared/services/time.service';
import { ContextAccessService } from './services/context-access.service';
import { NpaFmService } from './services/npa-fm.service';
import { TreeService } from './services/tree.service';
import { SocketService } from './services/socket.service';
import { PdfService } from './services/pdf.service';
// import { DashboardComponent } from './dashboard/dashboard.component';

export function init(bootService: BootService): () => void {
    return () => bootService.load();
}

@NgModule({
    declarations: [
        ...appComponents
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        MatListModule,
        appRoutes,
        SharedModule
    ],
    providers: [
        NpaFmService,
        InterceptorService,
        BootService,
        AuthService,
        ContextAccessService,
        HttpService,
        PdfService,
        RouteService,
        RouteGuardsService,
        RouterUtilityService,
        {
            provide: APP_INITIALIZER,
            useFactory: init,
            deps: [BootService],
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorService,
            deps: [],
            multi: true
        },
        TranslateService,
        DropdownService,
        ItemService,
        TreeService,
        TimeService,
        SocketService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
